export const homeAnalyticsEvents = ['carouselSlideVeranderd'] as const;
